module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"list_branch":"Branches List"},"si":{"list_branch":"කැඳවුම් ලැයිස්තුව"},"ta":{"list_branch":"Branches List"}}')
  delete Component.options._Ctor
}
